import Vue from 'vue'
import { getMenuList, toExternalSsoLogin } from '../../api/user'

// 懒加载 注意，动态加载路由需要
const loadView = (view, sorce) => {
  return (resolve) => view && require([`@/views${view}`], resolve)
}

const state = {
  functionKey: [],
  routes: [],
  addRoutes: [],
  menuList: []
}

const mutations = {
  SET_FUNCTIONLIST: (state, functionKey) => {
    state.functionKey = functionKey
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  },
  // 保存原始菜单数据
  SET_ORIGIN_MENU_LIST: (state, list) => {
    state.menuList = list
  }
}

const actions = {
  // 获取菜单
  getUserMenuList({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        appId: '',
        appIds: [6, 5],
        enableAppFilter: true
      }
      var routeList = []

      getMenuList(model).then(response => {
        const { data } = response
        const appId = Vue.prototype.$appId
        if (data !== null) {
          // 所有按钮权限
          commit('SET_FUNCTIONLIST', getFunctionKey(data.menuFunctionList))
          // 显示的菜单数据
          const tempHome = [{
            id: 332,
            menuName: '首页',
            parentId: 0,
            menuType: 1,
            menuKey: 'home',
            iconClass: 'icon-lie',
            link: '/home',
            sort: 1001,
            isCache: 0,
            isScreen: 0,
            systemId: 10,
            systemCode: 'ratePro',
            urlProfix: '90006',
            childNode: []
          }]
          const isUseHome = data.menuList.some(item => item.menuKey === 'home')
          let list = []
          if (isUseHome) {
            list = Object.assign([], data.menuList)
          } else {
            list = [...tempHome, ...data.menuList]
          }
          // 处理菜单连接
          commit('SET_ORIGIN_MENU_LIST', filterAsyncMenu(list))
          // 处理路由
          routeList = filterAsyncRouter(list)
        }
        if (Number(appId) === 90002) {
          // 个人设置
          routeList.push({
            path: '/90002/personal',
            name: 'personal',
            meta: {
              title: '个人设置'
            },
            component: loadView('/personal'),
            hidden: true
          })
        }
        if (appId) {
          routeList.push({ path: '*', redirect: '/home', hidden: true })
          // const flag = data.menuList.some(item => item.menuKey === 'home')
          // if (flag) {
          //   routeList.push({ path: '*', redirect: '/home', hidden: true })
          // } else {
          //   routeList.push({ path: '*', redirect: '/404', hidden: true })
          // }
        }
        commit('SET_ROUTES', routeList)
        resolve(routeList)
      }).catch(error => {
        reject(error)
      })
    })
  },
  handleToExternalSsoLogin() {
    return new Promise((resolve, reject) => {
      if (window.location.search) {
        const query = window.location.search.split('=')?.[1]
        toExternalSsoLogin({ code: query }).then((res) => {
          if (res.code === 200) {
            localStorage.setItem('global_auth_token', 'd38440a8-6c75-4e7a-a6c2-1b2d5c5c2f8f')
            window && window.location.replace(window.location.host)
            resolve()
          } else {
            reject(res)
          }
        // resolve()
        }).catch((err) => {
          reject(err)
        })
      } else {
        // 本地环境
        // window && window.location.replace('http://test-iam.sdlandsea.net/#/passport/login?client_id=1180946496460161024&response_type=code&redirect_uri=http://test.sdlandsea.net')
        // 测试环境
        // window && window.location.replace('http://test-iam.sdlandsea.net/#/passport/login?client_id=1180946496460161024&response_type=code&redirect_uri=http://i-ebs-yj-admin.sdlandsea.net')
        // 生产环境
        window && window.location.replace('https://iam.sdland-sea.com/#/passport/login?client_id=1180946496460161024&response_type=code&redirect_uri=https://fare.i-ebs.com')
        reject()
      }
      // resolve()
    })
  }
}

// 组装功能key
function getFunctionKey(data) {
  if (data && data.length > 0) {
    return data.map(item => item.functionKey)
  }
  return []
}

// 菜单递归处理连接
function filterAsyncMenu(list) {
  if (!list || list.length === 0) {
    return []
  }
  const func = (list, isLayout) => {
    return list.map(item => {
      const menuItem = {}
      setFactLink(menuItem, item, isLayout)

      const childNode = item.childNode || []

      return {
        ...item,
        ...menuItem,
        childNode: childNode.length ? func(item.childNode, false) : null
      }
    })
  }

  return func(list, true)
}

// 路由遍历
function filterAsyncRouter(menuList) {
  const routerList = []
  // 刷新
  routerList.push({
    path: '/redirect',
    hidden: true,
    // eslint-disable-next-line no-dupe-keys
    path: '/redirect/:path(.*)',
    component: () => import('../../redirect/index')
  })
  // 无权限
  routerList.push({
    path: '/404',
    component: () => import('../../error-page/404.vue'),
    hidden: true
  })
  if (menuList === null || menuList.length === 0) {
    return routerList
  }
  // 遍历后台传来的路由字符串，转换为组件对象
  menuList.forEach(menu => {
    // 记录页面的路径包含当前
    menu.parentPath = '/' + menu.menuKey

    var router = routerConvert(menu, true)
    // 是否存在子节点，
    if (menu.childNode && menu.childNode.length) {
      var list = []
      getChildMenu(menu.childNode, list, router.parentPath)
      // 子节点判断是否存在当前应用
      list = list.filter(item => {
        if (Number(item.urlProfix) === Number(Vue.prototype.$appId)) {
          return item
        }
      })
      if (list.length > 0) {
        list.forEach(child => {
          child.parentPath = menu.parentPath + '/' + child.menuKey
          routerList.push(routerConvert(child, false))
        })
      }
    }
    routerList.push(router)
  })
  return routerList
}
// 路由转换
function routerConvert(menu, isLayout) {
  var router = {}
  router.name = menu.menuKey
  router.parentPath = menu.parentPath

  setFactLink(router, menu, isLayout)

  router.id = menu.id
  router.menuType = menu.menuType
  const rootPath = '/' + menu.menuKey
  if (isLayout) {
    console.log(menu.link)
    // Layout组件特殊处理
    router.component = loadView(menu.link)
    router.path = rootPath
  } else {
    // var link = rootPath + (menu.link ? menu.link : '')
    // 处理组件---重点
    // 不带参数
    if (menu.link.indexOf(':') === -1) {
      router.component = loadView(menu.link)
    } else {
      // 带参数
      const link = menu.link.substring(0, menu.link.indexOf(':') - 1)
      router.component = loadView(link)
    }
    router.path = (menu.link ? menu.link : '')
  }
  var meta = {}
  meta.title = menu.menuName
  meta.keepAlive = !!menu.isCache
  if (menu.iconCloass) {
    // 默认图标处理
    meta.icon = menu.iconCloass
  } else {
    meta.icon = 'user'
  }
  // 页面是否需要菜单和头部布局
  meta.isScreen = !!menu.isScreen
  meta.parentPath = menu.parentPath
  router.meta = meta
  // 是否是页面
  if (menu.menuType === 2) {
    router.hidden = true
  }
  return router
}

// 判断是当前应用的路由还是其他系统，其他系统转成https访问，当前系统使用路由访问
// 若是第三方外链，则不作任何处理
function setFactLink(router, menu, isLayout) {
  // 是否是外链（指本公司系统内的非当前应用）
  // 当前应用id
  const appId = Vue.prototype.$appId
  // 对象所属的应用id
  const urlProfix = menu.urlProfix
  // 如果应用id存在，则属于本公司系统，默认为第三方链接
  if (urlProfix) {
    if (Number(appId) === Number(urlProfix)) {
      if (isLayout) {
        // 因为接口数据如果是layout，返回的link为null，需要手动设置根路由
        // router.link = '/' + Vue.prototype.$appId
        router.link = '/' + menu.menuKey
      } else {
        // 当前应用，直接赋值
        // router.link = '/' + Vue.prototype.$appId + menu.link
        router.link = menu.link
      }
    } else {
      if (isLayout) {
        router.link = 'http://' + window.location.hostname + '/' + menu.menuKey
      } else {
        router.link = 'http://' + window.location.hostname + '/' + urlProfix + menu.link
      }
    }
  } else {
    // 第三方链接，直接访问url
    router.link = menu.link
  }
}

// 递归获取子节点 parentPath=上级菜单的路径
function getChildMenu(childList, list, parentPath) {
  childList.forEach(item => {
    // 存储上级或本机菜单的路径
    if (parentPath) {
      item.parentPath = parentPath + '/' + item.menuKey
    }
    if (item.link) {
      list.push(item)
    }
    if (item.childNode && item.childNode.length > 0) {
      getChildMenu(item.childNode, list, item.parentPath)
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
